<template>
  <transition
    enter-active-class="transition-opacity duration-200"
    leave-active-class="transition-opacity duration-200"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div
      v-if="updateStatus !== 'idle'"
      class="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-md bg-background/95 px-4 py-2 text-sm shadow-lg ring-1 ring-border backdrop-blur-sm"
      role="status"
    >
      <Spinner v-if="updateStatus === 'downloading'" />
      <CircleAlertIcon v-else-if="updateStatus === 'failed'" class="size-4 text-danger" aria-hidden="true" />
      <span>{{ t(messageKey) }}</span>
    </div>
  </transition>
</template>

<script setup>
import { Spinner } from "@/components/ui/spinner";
import { CircleAlertIcon } from "lucide-vue-next";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { updateStatus } from "../capacitor/app-updater";

const { t } = useI18n();

const STATUS_MESSAGE_KEYS = {
  downloading: "msg.appUpdateDownloading",
  failed: "msg.appUpdateFailed",
};

const messageKey = computed(() => STATUS_MESSAGE_KEYS[updateStatus.value] ?? STATUS_MESSAGE_KEYS.downloading);
</script>
